import { useState, useEffect, useRef } from "react";
import {
  Grid,
  FormControl,
  TextField,
  Button,
  Tooltip,
  Autocomplete,
  DataGrid,
  CurrencyInput,
  IconButton,
  InputAdornment,
  DocumentoProdutoAplicacaoDialog,
  TextFielDecimalNumbers,
  ProdutoEstoqueInformacaoDialog,
  OrdemCompraDialog,
  Typography,
  ListBoxAutocomplete,
} from "../../../../../components";
import { ProdutoSimilarDialog, ImpostoProdutoDialog } from "..";
import {
  notification,
  ProdutosService,
  UnidadeComercialService,
  CsoSimplesService,
  GruposTributarioService,
  ModeloTributacaoService,
  EnquadramentoLegalService,
  GruposTributarioModelosTributacaoService,
  SessionService,
  CstService,
} from "../../../../../services";
import { PermisoesHelper, value } from "../../../../../helpers";
import {
  responseErros,
  formatPrice,
  unformatPrice,
  timeoutBuscaAutocomplete,
  formatPrecisaoFloat,
} from "../../../../../utils";
import { NfSaidaItem, NfSaidaItemImpostos } from "../../../entities";
import { 
  calcularPrecoProduto, 
  calculoDesconto, 
  validarTabelaTodosProdutosMeioPagamento, 
  validarTabelaVendaCliente, 
  validarTabelaVendaMeioPagamento 
} from "../../add-nf-saida";
import shortid from "shortid";
import TabelaCustoDialog from "../../../../../components/tabela-custo-dialog/tabela-custo-dialog.component";

const produtoService = new ProdutosService();
const unidadeComercialService = new UnidadeComercialService();
const gruposTributarioService = new GruposTributarioService();
const csoSimplesService = new CsoSimplesService();
const modeloTributacaoService = new ModeloTributacaoService();
const enquadramentoLegalService = new EnquadramentoLegalService();
const gruposTributarioModelosTributacaoService =
  new GruposTributarioModelosTributacaoService();
const cstService = new CstService();

const NfSaidaItens = ({
  nfSaidaId,
  nfSaida,
  setNfSaida,
  nfSaidaEntity,
  nfSaidaProdutos,
  item,
  setItem,
  tabelas,
  listaProdutosSimilares,
  setListaProdutosSimilares,
  setNfSaidaProdutos,
  setNfSaidaPagamentos,
  setLoading,
  permitirVendaEstoqueNegativo,
  situacaoIpiList,
  origensMercadoriasList,
  operacaoFiscal,
  unidadeList,
  setUnidadeList,
  gruposTributacaoList,
  setGruposTributacaoList,
  csoSimplesList,
  setCsoSimplesList,
  situacaoIbsList,
  setSituacaoIbsList,
  classificacaoIbsList,
  setClassificacaoIbsList,
  enquadramentoLegalList,
  setEnquadramentoLegalList,
  permissaoEditarPrecoVenda,
  meioPagamentoSelecionado,
  acrescimoPagamento,
  produto,
  setProduto,
  clienteSelecionado,
  buscarNotasCredito,
  transferencia,
  tabelasTodosProdutos
}) => {
  const inputRef = useRef();
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);

  const [listaProdutos, setListaProdutos] = useState([]);
  const [modeloTributacao, setModeloTributacao] = useState({});
  const [openProdutoSimilarDialog, setOpenProdutoSimilarDialog] =
    useState(false);
  const [openProdutoAplicacoesDialog, setOpenProdutoAplicacoesDialog] =
    useState(false);
  const [
    openProdutoEstoqueInformacaoDialog,
    setOpenProdutoEstoqueInformacaoDialog,
  ] = useState(false);
  const [openImpostoProdutoDialog, setImpostoProdutoDialog] = useState(false);
  const [itensColumnView, setItensColumnView] = useState(false);
  const [isProdutoEdit, setIsProdutoEdit] = useState(false);
  const [produtosTabelaCusto, setProdutosTabelaCusto] = useState([]);
  const [totaisTabelaCusto, setTotaisTabelaCusto] = useState([]);
  const [openTabelaCustoDialog, setOpenTabelaCustoDialog] = useState(false);
  const [openOrdemCompraDialog, setOpenOrdemCompraDialog] = useState(false);

  const permissoesHelper = new PermisoesHelper();
  const tabelaCustoPermissao = permissoesHelper.temPermisao(
    "tabela-custo-visualizar",
  );
  const ordemCompraPermissao = permissoesHelper.temPermisao(
    "ordem-compra-visualizar",
  );

  const sessionService = new SessionService();
  const { configuracoes } = sessionService.getEmpresa();
  const usuario = sessionService.getUsuario();

  const produtosColunasSimilares = [
    {
      field: "codigo",
      headerName: "Cod.",
      flex: 280,
    },
    {
      field: "descricao",
      headerName: "Produtos",
      flex: 700,
    },
    {
      field: "estoqueAtual",
      headerName: "Estoque",
      flex: 350,
    },
    {
      field: "precoVenda",
      headerName: "Preço Venda",
      flex: 500,
      valueGetter: (params) => formatPrice(params.value),
    },
    {
      field: "acoes",
      sortable: false,
      disableClickEventBubbling: true,
      renderHeader: () => {
        return (
          <i
            className="ph-fill ph-note-pencil"
            style={{ fontSize: 20, marginLeft: 14 }}
          ></i>
        );
      },
      renderCell: (params) => {
        return (
          <IconButton
            onClick={() => {
              if (params.row) {
                setOpenProdutoSimilarDialog(false);
                setListaProdutosSimilares([]);
                handleChangeAutocompleteProduto(params.row, false, true);
              }
            }}
            sx={{
              "&:hover": { backgroundColor: "transparent" },
            }}
          >
            <i
              className="ph-fill ph-paper-plane-right"
              style={{ fontSize: 20, marginLeft: 14 }}
            ></i>
          </IconButton>
        );
      },
    },
  ];

  const produtosColunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Produto",
      flex: 500,
    },
    {
      field: "quantidade",
      headerName: "Qtd.",
      flex: 90,
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        Number.isInteger(parseFloat(params.value))
          ? params.value
          : parseFloat(params.value).toFixed(3).replace(".", ","),
    },
    {
      field: "valor",
      headerName: "Valor (R$)",
      flex: 200,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) => formatPrice(parseFloat(params.value)),
    },
    {
      field: "subtotal",
      headerName: "Subtotal (R$)",
      flex: 180,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) => formatPrice(parseFloat(params.value)),
    },
    {
      field: "desconto",
      headerName: "Desconto (R$)",
      flex: 150,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) => formatPrice(parseFloat(params.value)),
    },
    {
      field: "total",
      headerName: "Total (R$)",
      flex: 180,
      headerAlign: "right",
      align: "right",
      valueGetter: (params) => {
        const frete =
          nfSaida?.freteCompoeNota && params.row.frete
            ? parseFloat(params.row.frete)
            : 0;
        return formatPrice(
          parseFloat(params.row.subtotal) -
            parseFloat(params.row.desconto || 0) +
            frete +
            parseFloat(params.row.despesas || 0),
        );
      },
    },
    {
      field: "acoes",
      headerName: "Ações",
      sortable: false,
      flex: 100,
      align: "center",
      headerAlign: "center",
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <div>
            {operacaoFiscal?.modeloDocumento !== "01" && (
              <IconButton
                onClick={() => {
                  handleViewImposto(params.id);
                }}
              >
                <Tooltip title="Visualizar Imposto" arrow placement="right">
                  <i className="ph-fill ph-eye" style={{ fontSize: 18 }}></i>
                </Tooltip>
              </IconButton>
            )}
            {!params.row.origemKitId && !nfSaidaId && (
              <IconButton
                onClick={() => {
                  handleEditarProduto(params.id);
                }}
              >
                <Tooltip title="Editar" arrow placement="right">
                  <i className="ph-fill ph-pencil" style={{ fontSize: 18 }}></i>
                </Tooltip>
              </IconButton>
            )}
            {!nfSaidaId && (
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  handleRemoverProduto(params.id);
                }}
              >
                <Tooltip title="Excluir" arrow placement="right">
                  <i className="ph-fill ph-trash" style={{ fontSize: 18 }}></i>
                </Tooltip>
              </IconButton>
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    buscarUnidadesComerciais();
    buscarGruposTributario();
    buscaCsoSimples();
    buscaEnquadramentoLegal();
  }, []);

  const buscarProdutos = (
    filtros,
    isProdutoSimilar = false,
    isCodigoBarras = false,
  ) => {
    const filtro = {
      ...filtros,
      orderBy: "codigo",
      order: "asc",
      ativado: true,
      tabelasVenda: true,
      limite: 20,
    };
    produtoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setLoadingAutoComplete(false);
        if (isProdutoSimilar && result.data.rows?.length) {
          const itens = result.data.rows.map((item) => {
            const { informacao, ...rest } = item;
            const produtoResultante = { ...rest, ...informacao, id: rest.id };
            return montarItem(produtoResultante, false);
          });
          setListaProdutosSimilares(itens);
          setLoading(false);
          return;
        }

        if (isCodigoBarras) {
          handleChangeAutocompleteProduto(result.data.rows[0], true);
        } else {
          setListaProdutos(result.data.rows);
        }
      } else {
        setLoadingAutoComplete(false);
        setLoading(false);
        responseErros(result);
      }
    });
  };

  const buscarProdutoKit = async (produtoId) => {
    if (produtoId) {
      const result = await produtoService.getById(produtoId);
      if (!result.isAxiosError) {
        return result.data;
      } else {
        responseErros(result);
      }
    }
  };

  const buscarProdutosByCodigo = async (codigoBarra, valorProduto) => {
    const result = await produtoService.getAllProdutosByCodigo({ codigoBarra });
    if (!result.isAxiosError) {
      setLoadingAutoComplete(false);
      if (result.data.length === 0) return;
      let produto = result.data[0];
      let quantidade = null;
      if (valorProduto) {
        quantidade =
          Math.round((valorProduto / produto.informacao.precoVenda) * 1000) /
          1000;
      }
      produto = {
        ...produto,
        quantidade,
        totalItem: valorProduto,
      };
      handleChangeAutocompleteProduto(produto, true, false, !!valorProduto);
      setLoading(false);
    } else {
      setLoadingAutoComplete(false);
      responseErros(result);
    }
  };

  const buscaEnquadramentoLegal = () => {
    if (enquadramentoLegalList?.length) return;
    enquadramentoLegalService.getAll().then((result) => {
      if (!result.isAxiosError) {
        setEnquadramentoLegalList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscaCsoSimples = () => {
    if (csoSimplesList?.length) return;
    csoSimplesService.getAll().then((result) => {
      if (!result.isAxiosError) {
        setCsoSimplesList(result.data);
      }
    });
  };

  const buscarGruposTributario = () => {
    if (gruposTributacaoList?.length) return;
    const filter = {
      ativado: true,
      nonPaginated: true,
    };
    gruposTributarioService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setGruposTributacaoList(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscarModeloTributacao = async (item) => {
    const result = await modeloTributacaoService.getById(
      item.modeloTributacaoId,
    );
    if (!result.isAxiosError) {
      setModeloTributacao(result.data);
      await buscaCstIbs(item);
    } else {
      responseErros(result);
    }
  };

  const buscaCstIbs = async (item) => {
    const filtros = {
      codigo_classificacao: item.tributosIbsClassificacao,
    };
    cstService.getAllCstIbs({ filtros }).then((result) => {
      if (!result.isAxiosError) {
        setSituacaoIbsList(result.data);
        setClassificacaoIbsList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const buscarUnidadesComerciais = async () => {
    if (unidadeList?.length) return;
    const filtros = {
      nonPaginated: true,
    };
    unidadeComercialService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setUnidadeList(result.data);
      } else {
        responseErros(result);
      }
    });
  };

  const handleInputChange = (e) => {
    setItem((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleInputBlur = (event) => {
    const valor = parseFloat(unformatPrice(event.target.value));
    let itemTemp = {
      ...produto,
      [event.target.name]: valor || null,
    };
    if (
      acrescimoPagamento &&
      event.target.name == "valor" &&
      parseFloat(valor) !== item.valor
    ) {
      itemTemp.valor = formatPrecisaoFloat(
        parseFloat(valor) + parseFloat(valor) * (acrescimoPagamento / 100),
      );
      itemTemp.desconto = item?.descontoPorcentagem
        ? (total * parseFloat(item?.descontoPorcentagem)) / 100
        : null;
    }
    const total = itemTemp[event.target.name] * (item?.quantidade || 1);
    itemTemp.subtotal = total;
    setItem((prevState) => ({ ...prevState, ...itemTemp }));
  };

  const handleInputDesconto = (event) => {
    if (!item) return;
    const valor = unformatPrice(event.target.value);

    const itemTemp = {
      ...item,
      [event.target.name]: valor || 0,
    };
    if (event.target.name === "desconto") {
      const subtotal = itemTemp.valor * itemTemp.quantidade;
      if (parseFloat(itemTemp.desconto) > subtotal) {
        itemTemp.desconto = subtotal;
      }
      itemTemp.descontoPorcentagem = calculoDesconto([item], itemTemp, false);
      setItem(itemTemp);
    } else {
      itemTemp.desconto = calculoDesconto([item], itemTemp);
      setItem(itemTemp);
    }
  };

  const handleInputBlurAcrescimos = (event) => {
    if (!item) return;
    const valor = unformatPrice(event.target.value);
    const itemTemp = {
      ...item,
      [event.target.name]: valor || 0,
    };
    setItem(itemTemp);
  };

  const onInputChangeProdutos = (event) => {
    const eventValue = event.target?.value.includes(",")
      ? event.target?.value.split(",")[0]
      : event.target?.value;
    if (
      event.key === "Backspace" &&
      inputRef.current === document.activeElement &&
      eventValue === ""
    ) {
      setListaProdutos([]);
    }
    if (event.key === "Enter" && inputRef.current === document.activeElement) {
      const filtros = {
        codigo: eventValue,
        descricao: eventValue,
        codigoBarra: eventValue,
      };
      const validacaoCodigoNumerico = Number.isFinite(parseFloat(eventValue));
      const isCodigoBalanca =
        configuracoes.inicialCodigoBarrasBalanca ===
          parseFloat(eventValue[0]) && eventValue.length >= 7;
      setLoadingAutoComplete(true);
      if (
        validacaoCodigoNumerico &&
        (configuracoes.buscaProdutosCodigoBarras || isCodigoBalanca)
      ) {
        const codigo = isCodigoBalanca ? eventValue.slice(0, 7) : eventValue;
        let valorProduto = null;
        if (isCodigoBalanca && eventValue.length >= 12) {
          valorProduto =
            parseInt(eventValue.slice(7, 12).replace(/^0+/, "")) / 100;
        }
        timeoutBuscaAutocomplete(buscarProdutosByCodigo(codigo, valorProduto));
      } else {
        const isCodigoBarras =
          validacaoCodigoNumerico && eventValue.length >= 8;
        timeoutBuscaAutocomplete(
          buscarProdutos(filtros, false, isCodigoBarras),
        );
      }
    }
  };

  function verificaEstoque(produto, isSimilar) {
    if (!nfSaidaEntity?.operacaoEntrada && !permitirVendaEstoqueNegativo) {
      const {
        estoqueProduto: { estoque },
        estoqueMinimo,
      } = produto;

      if (!estoque || estoque < 0) {
        if (usuario.acessosEmpresas?.length > 1) return true;
        notification.alertaGenericos("Produto fora de estoque");
        if (!isSimilar) setProduto(null);
        return true;
      }

      if (estoque <= estoqueMinimo) {
        notification.alertaGenericos("Produto no limite de estoque minimo");
        return false;
      }
    }
    return false;
  }

  const handleChangeAutocompleteProduto = (
    produtoEscolhido,
    isBuscaCodBar = false,
    isSimilar = false,
    isLeituraBalanca = false,
  ) => {
    document.getElementById("produtoId").blur();
    if (produtoEscolhido) {
      const { informacao, ...rest } = produtoEscolhido;
      let produtoResultante = { ...rest, ...informacao, id: rest.id };
      if (produtoEscolhido.tipo === "kit") {
        produtoResultante = {
          ...produtoResultante,
          desconto: null,
          descontoPorcentagem: null,
          frete: null,
          despesas: null,
        };
      }
      const estoque = verificaEstoque(produtoResultante, isSimilar);
      if (estoque && usuario.acessosEmpresas?.length === 1) return;
      const itemTemp = montarItem(produtoResultante, true, isLeituraBalanca);
      setProduto(produtoResultante);
      setItem(itemTemp);
      if (produtoResultante.similares?.length && !isBuscaCodBar) {
        const listaIdsProdutosSimilares = produtoResultante.similares.map(
          ({ similarId }) => similarId,
        );
        setLoading(true);
        buscarProdutos({ id: listaIdsProdutosSimilares }, true);
      }
      if (usuario.acessosEmpresas?.length > 1 && estoque) {
        openEstoqueDialog(produtoResultante);
      } else if (!isBuscaCodBar) {
        document.getElementById("buttonAdicionar").focus();
      } else {
        handleAdicionarProduto(produtoResultante, itemTemp);
      }
    } else {
      setProduto(null);
      setItem(null);
      setListaProdutosSimilares([]);
    }
  };

  const montarItem = (
    produtoResultante,
    insertItem = true,
    isLeituraBalanca = false,
  ) => {
    const valor =
      acrescimoPagamento > 0 && !isLeituraBalanca
        ? produtoResultante.precoVenda +
          formatPrecisaoFloat(
            produtoResultante.precoVenda * (acrescimoPagamento / 100),
          )
        : produtoResultante.precoVenda;
    const quantidade =
      (produtoResultante?.embalagem || produtoResultante?.quantidade) ?? 1;
    const subtotal =
      produtoResultante.totalItem ?? formatPrecisaoFloat(valor * quantidade);
    const frete =
      nfSaida?.freteCompoeNota && produtoResultante.frete
        ? produtoResultante.frete
        : 0;
    const total =
      subtotal -
      (produtoResultante.desconto || 0) +
      frete +
      (produtoResultante.despesas || 0);

    let itemTemp = {
      ...produtoResultante,
      id: shortid.generate(),
      produtoId: produtoResultante?.produtoId || produtoResultante.id,
      valor,
      subtotal,
      total,
      desconto: produtoResultante?.descontoPorcentagem
        ? (subtotal * parseFloat(produtoResultante?.descontoPorcentagem)) / 100
        : null,
      estoque: produtoResultante?.estoqueProduto?.estoque
        ? `${produtoResultante.estoqueProduto.estoque}`
        : "0",
      estoqueAtual: produtoResultante?.estoqueProduto?.estoque
        ? `${produtoResultante.estoqueProduto.estoque}`
        : "0",
      unidade: unidadeList.find(
        (item) => item.id == produtoResultante?.unidadeComercialVendaId,
      )?.codigo,
      tributosIcmsOrigem: origensMercadoriasList.find(
        (item) => item.id == produtoResultante.origemMercadoriaId,
      )?.codigo,
      quantidade,
      codigo: produtoResultante?.codigo,
      ncm: produtoResultante?.ncmCodigo,
      tipo: produtoResultante?.tipo,
    };
    if (insertItem) {
      itemTemp = { ...item, ...itemTemp };
    }
    let resultItem = { ...itemTemp };
    
    const tabelaTodosProdutos = validarTabelaTodosProdutosMeioPagamento(
      tabelasTodosProdutos, 
      meioPagamentoSelecionado?.id
    );
    if (
      validarTabelaVendaCliente(
        tabelas?.cliente, 
        resultItem.produtoId
      )
    ) {
      resultItem = calcularPrecoProduto(
        resultItem,
        tabelas?.cliente,
      );
    } else if (tabelas?.grupoPessoa) {
      resultItem = calcularPrecoProduto(
        resultItem,
        tabelas?.grupoPessoa,
      );
    } else if (
      validarTabelaVendaMeioPagamento(
        produtoResultante?.tabelasVenda, 
        meioPagamentoSelecionado?.id
    )) {
      resultItem = calcularPrecoProduto(
        resultItem,
        resultItem?.tabelasVenda[0] || {},
        "meioPagamento"
      );
    } else if (tabelaTodosProdutos) {
      resultItem = calcularPrecoProduto(
        resultItem,
        tabelaTodosProdutos,
      );
    } 
    return resultItem;
  };

  const validarAddProduto = (produto, item) => {
    if (!produto) {
      notification.alertaGenericos("Selecione um produto para adicionar");
      return true;
    }
    if (!item.unidade) {
      notification.erroValidacao("Unidade do produto");
      return true;
    }
    if (!item.quantidade) {
      notification.erroValidacao("Quantidade do produto");
      return true;
    }
    /* if (!item.valor) {
      notification.erroValidacao("Valor Unitário do produto");
      return true;
    } */
  };

  const extrairItensKit = (produtoKit) => {
    return produtoKit.kits.map((itemKit) => {
      const produtoTemp = {
        ...itemKit.produto,
        ...itemKit.produto.informacao,
        id: itemKit.produto.id,
      };
      const itemTemp = montarItem(produtoTemp);
      const formatItemKit = {
        ...itemTemp,
        origemKitId: produto.id,
        subtotal: formatPrecisaoFloat(
          parseFloat(itemTemp?.valor ?? 0) *
            parseFloat((item?.quantidade ?? 1) * itemKit.quantidade),
        ),
        quantidade: item.quantidade * itemKit.quantidade,
        quantidadeKit: item.quantidade,
      };
      const nfSaidaItem = new NfSaidaItem(
        formatItemKit,
        nfSaida.nfSaidaItens?.length,
        operacaoFiscal,
        origensMercadoriasList,
        unidadeList,
      );
      if (nfSaidaItem === null) {
        return notification.alertaGenericos("Produto sem imposto");
      }
      return nfSaidaItem;
    });
  };

  const verificarPagamentosNotaCredito = () => {
    const notaCredito = nfSaidaEntity.nfSaidaPagamentos.filter(
      (item) =>
        item.meioPagamentoSelecionado?.nfePagamento == "fpCreditoEmLoja",
    );
    if (notaCredito.length > 0) {
      return buscarNotasCredito(clienteSelecionado.id);
    }
  };

  const handleAdicionarProduto = async (produto, item) => {
    const produtoIsValid = validarAddProduto(produto, item);
    if (produtoIsValid) return;
    let produtoKit = null,
      nfSaidaProdutosTemp = [];
    if (produto.tipo === "kit") {
      produtoKit = await buscarProdutoKit(produto.id);
    }
    if (
      (nfSaidaProdutos.length == 1 || produtoKit) &&
      nfSaida.chaveAcessoReferencia
    ) {
      return notification.alertaGenericos(
        "É permitido adicionar apenas um produto",
      );
    } else if (item?.itemEditado) {
      const produtoIndex = nfSaidaProdutos.findIndex(
        (obj) => obj.id == produto.id,
      );
      const subtotal = formatPrecisaoFloat(
        parseFloat(item?.valor ?? 0) * parseFloat(item?.quantidade ?? 1),
      );
      nfSaidaProdutosTemp = [
        ...nfSaidaProdutos.map((obj, index) => {
          if (index == produtoIndex) {
            return {
              ...obj,
              ...item,
              subtotal,
            };
          }
          return obj;
        }),
      ];
    } else {
      let nfSaidaItens = [];
      if (produtoKit && produto.envioKitItensFiscal) {
        nfSaidaItens = extrairItensKit(produtoKit);
      } else {
        if (produtoKit) {
          item.produtosKit = produtoKit.kits.map((itemKit) => ({
            produtoId: itemKit.produto.id,
            quantidade: itemKit.quantidade,
          }));
        }
        const nfSaidaItem = new NfSaidaItem(
          item,
          nfSaida.nfSaidaItens?.length,
          operacaoFiscal,
          origensMercadoriasList,
          unidadeList,
        );
        nfSaidaItem.setSubtotal();
        if (nfSaidaItem === null) {
          return notification.alertaGenericos("Produto sem imposto");
        }
        nfSaidaItens.push(nfSaidaItem);
      }
      const formatNfSaidaItens = nfSaidaItens.map((nfSaidaItem) => ({
        ...item,
        ...nfSaidaItem,
        produto: nfSaidaItem?.descricao,
        quantidade: nfSaidaItem?.quantidade ?? item?.quantidade ?? 1,
        subtotal: nfSaidaItem?.subtotal,
      }));
      nfSaidaProdutosTemp = [...nfSaidaProdutos, ...formatNfSaidaItens];
    }
    verificarPagamentosNotaCredito();
    setNfSaidaProdutos(nfSaidaProdutosTemp);
    nfSaidaEntity.setChangeItens(nfSaidaId, nfSaidaProdutosTemp);
    setNfSaidaPagamentos([]);
    nfSaidaEntity.setChangePagamentos([]);
    setNfSaida(nfSaidaEntity);
    document.getElementById("produtoId").focus();
    setIsProdutoEdit(false);
    setListaProdutosSimilares([]);
    setProduto(null);
    setItem(null);
    setListaProdutos([]);
    setItensColumnView(false);
  };

  const handleRemoverProduto = async (id) => {
    const produtoSelecionado = nfSaidaProdutos.find((item) => item.id === id);
    let data = [];
    if (produtoSelecionado.origemKitId) {
      data = nfSaidaProdutos.filter(
        (item) => item.origemKitId !== produtoSelecionado.origemKitId,
      );
    } else {
      data = nfSaidaProdutos.filter((item) => item.id !== id);
    }
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir ${produtoSelecionado.descricao}?`,
    );
    if (retornoAlerta.isConfirmed) {
      setNfSaidaProdutos(data);
      nfSaidaEntity.setChangeItens(nfSaidaId, data);
      if (!nfSaidaId) {
        verificarPagamentosNotaCredito();
        setNfSaidaPagamentos([]);
        nfSaidaEntity.setChangePagamentos([]);
      }
      setNfSaida(nfSaidaEntity);
    }
  };

  const handleEditarProduto = async (id) => {
    const item = nfSaidaProdutos.find((item) => item.id === id);
    if (item) {
      setIsProdutoEdit(true);
    }
    setProduto(item);
    setItem({
      ...item,
      unidade: unidadeList.find(
        (unidade) =>
          unidade.codigo == item.unidade ||
          unidade.id == item.unidadeComercialVendaId,
      )?.codigo,
      itemEditado: true,
    });
  };

  const openProdutoSimilar = () => {
    if (produto === null) {
      notification.alertaGenericos(
        "Selecione um produto primeiro para colocar produto similar",
      );
    } else {
      setOpenProdutoSimilarDialog(true);
    }
  };

  const openAplicacoesDialog = () => {
    if (produto === null) {
      notification.alertaGenericos(
        "Selecione um produto primeiro para colocar produto similar",
      );
    } else {
      setOpenProdutoAplicacoesDialog(true);
    }
  };

  const openEstoqueDialog = (produtoEscolhido = produto) => {
    if (produtoEscolhido === null) {
      notification.alertaGenericos("Selecione um produto primeiro");
    } else {
      setOpenProdutoEstoqueInformacaoDialog(true);
    }
  };

  const handleViewImposto = async (id) => {
    const item = nfSaidaProdutos.find((item) => item.id === id);
    if (!item) return notification.alertaGenericos("Sem produto selecionado");
    let itemTemp = { ...item };
    if (!nfSaidaId && !item?.itemEditado) {
      const impostoModelo = await buscaImpostoProduto(
        itemTemp.grupoTributacaoId,
        nfSaida?.operacaoFiscalId,
      );
      if (impostoModelo) {
        const nfSaidaItemImpostos = new NfSaidaItemImpostos(
          impostoModelo,
          item,
          nfSaida,
        );
        if (nfSaida.documentoDevolucaoFornecedor) {
          const { tributosIcmsCsosn, cfop, modeloTributacaoId } =
            nfSaidaItemImpostos;
          itemTemp = { ...item, tributosIcmsCsosn, cfop, modeloTributacaoId };
        } else {
          itemTemp = { ...item, ...nfSaidaItemImpostos };
        }
      }
    } else {
      itemTemp.id = nfSaidaEntity.nfSaidaItens[item.ordem - 1].id;
    }
    setProduto({ ...itemTemp });
    await buscarModeloTributacao(itemTemp);
    setImpostoProdutoDialog(true);
  };

  const buscaImpostoProduto = async (grupoTributarioId, operacaoFiscalId) => {
    setLoading(true);
    const filtro = {
      grupoTributarioId: grupoTributarioId,
      operacaoFiscalId,
    };
    const result =
      await gruposTributarioModelosTributacaoService.getAllFiltroAvancado(
        filtro,
      );
    setLoading(false);
    if (!result.isAxiosError) {
      if (result.data.rows.length) {
        return result.data.rows[0];
      }
    } else {
      responseErros(result);
    }
    return null;
  };

  const handleAddActionsOpen = () => {
    if (!item) {
      return notification.alertaGenericos("Selecione um produto");
    }
    setItensColumnView(!itensColumnView);
  };

  function onBlurQtd(e) {
    const value = parseFloat(e.target.value) * 100;
    const embalagem = produto?.embalagem * 100;
    if (embalagem && value % embalagem) {
      e.target.value = (Math.ceil(value / embalagem) * embalagem) / 100;
      handleInputChange(e);
    }
    const itemTemp = montarItem({
      ...produto,
      ...item,
      quantidade: item?.quantidade,
      produtoId: produto?.produtoId,
    });
    setItem((prevState) => ({ ...prevState, ...itemTemp }));
  }

  const handleOpenTabelaCustoDialog = () => {
    const produtosTabelaCusto = nfSaidaProdutos.map((item) => {
      const quantidade = item.quantidade || 0;
      const precoCusto = item.precoCusto || 1;
      const precoVenda = item.total || 1;
      const totalCustoItem = precoCusto * quantidade;
      const diferenca = ((precoVenda - totalCustoItem) / totalCustoItem) * 100;
      return {
        ...item,
        total: formatPrice(totalCustoItem, false),
        dif: formatPrice(diferenca, false),
      };
    });
    let totaisTabelaCusto = { totalCusto: 0, totalVenda: 0 };
    nfSaidaProdutos.forEach((item) => {
      const totalCusto =
        totaisTabelaCusto.totalCusto +
        (item.precoCusto || 0) * (item.quantidade || 0);
      const totalVenda = totaisTabelaCusto.totalVenda + item.total || 0;
      totaisTabelaCusto.totalCusto = Math.round(totalCusto * 100) / 100;
      totaisTabelaCusto.totalVenda = Math.round(totalVenda * 100) / 100;
    });

    const totalDif =
      totaisTabelaCusto.totalVenda - totaisTabelaCusto.totalCusto;
    totaisTabelaCusto = {
      ...totaisTabelaCusto,
      totalDif: formatPrice(totalDif, false),
      percentualDif: formatPrice(
        (totalDif / totaisTabelaCusto.totalCusto) * 100,
        false,
      ),
    };

    setProdutosTabelaCusto(produtosTabelaCusto);
    setTotaisTabelaCusto(totaisTabelaCusto);
    setOpenTabelaCustoDialog(true);
  };

  const renderSizeItemAutocomplete = () => {
    if (listaProdutosSimilares?.length || produto?.aplicacoes?.length) {
      if (listaProdutosSimilares?.length && produto?.aplicacoes?.length) {
        return 4.5;
      } else {
        return 5;
      }
    } else {
      return 5.5;
    }
  };

  return (
    <Grid container className="position-relative">
      <Grid
        container
        spacing={2}
        className="mb-2"
        alignItems="center"
        justifyContent="space-between"
        columns={15}
      >
        <Grid item xs={renderSizeItemAutocomplete()}>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <Autocomplete
              ListboxComponent={ListBoxAutocomplete}
              id="produtoId"
              name="produtoId"
              options={listaProdutos}
              autoHighlight
              disabled={
                (nfSaidaId || !nfSaida?.operacaoFiscalId) && !transferencia
              }
              loading={loadingAutoComplete}
              loadingText="Carregando"
              noOptionsText="Digite e pressione Enter"
              renderOption={(props, option) => {
                let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
                return option ? (
                  <li {...props} style={{ background: "transparent" }}>
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <div>
                        <span className="fw-bold">{descricaoProduto}</span>
                        <div className="d-flex gap-3">
                          <Typography variant="body2">
                            Unidade:{" "}
                            {
                              value.autoComplete(
                                unidadeList || [],
                                option?.unidadeComercialVendaId,
                              ).codigo
                            }
                          </Typography>
                          <Typography variant="body2">
                            Cód.barra: {option?.codigoBarra}
                          </Typography>
                        </div>
                        <Typography variant="body2" className="fw-bolder">
                          Estoque disponível:{" "}
                          <span
                            className={
                              option?.estoqueProduto?.estoque < 0
                                ? "text-danger"
                                : "text-success"
                            }
                          >
                            {option?.estoqueProduto?.estoque}
                          </span>
                        </Typography>
                      </div>
                      <div className="text-end">
                        <Typography variant="body2">Preço venda</Typography>
                        <span className="fs-6">
                          {formatPrice(option?.informacao?.precoVenda || 0)}
                        </span>
                      </div>
                    </div>
                  </li>
                ) : (
                  ""
                );
              }}
              getOptionLabel={(option) => {
                let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
                if (option?.codigoBarra) {
                  descricaoProduto = `${option?.codigoBarra} - ${option?.codigo} - ${option?.descricao}`;
                }
                return option ? descricaoProduto : "";
              }}
              filterSelectedOptions
              onChange={(_, newValue) =>
                handleChangeAutocompleteProduto(newValue)
              }
              value={produto}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant={"outlined"}
                  label="Buscar produto"
                  onKeyDown={(e) => onInputChangeProdutos(e)}
                  inputRef={inputRef}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>
        <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
          <Tooltip title="Estoque e Informação do Item" placement="bottom">
            <Button
              id="buttonEstoqueInformacaoItem"
              variant="contained"
              color="primary"
              disabled={
                nfSaidaId || !nfSaida?.operacaoFiscalId
                  ? true
                  : false || !produto
              }
              size="small"
              sx={{
                height: "35px",
                borderRadius: "20%",
                minWidth: "15px",
                boxShadow: "none",
              }}
              onClick={() => openEstoqueDialog()}
            >
              <i
                className="ph-fill ph-package"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          </Tooltip>
        </Grid>
        {produto?.aplicacoes?.length ? (
          <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
            <Tooltip title="Aplicações do item" placement="bottom">
              <Button
                id="buttonAplicacoesItem"
                variant="contained"
                color="primary"
                disabled={
                  nfSaidaId || !nfSaida?.operacaoFiscalId ? true : false
                }
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => openAplicacoesDialog()}
              >
                <i
                  className="ph-fill ph-circles-three"
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
          </Grid>
        ) : null}
        {listaProdutosSimilares?.length ? (
          <Grid item xs={0.5} sx={{ mt: "0.5em" }}>
            <Tooltip title="Consultar Similares" placement="bottom">
              <Button
                id="buttonSimilarItem"
                variant="contained"
                color="primary"
                disabled={
                  nfSaidaId || !nfSaida?.operacaoFiscalId ? true : false
                }
                size="small"
                sx={{
                  height: "35px",
                  borderRadius: "20%",
                  minWidth: "15px",
                  boxShadow: "none",
                }}
                onClick={() => openProdutoSimilar()}
              >
                <i
                  className="ph-bold ph-approximate-equals"
                  style={{ color: "#fff", fontSize: 15 }}
                ></i>
              </Button>
            </Tooltip>
          </Grid>
        ) : null}
        <Grid item xs={1}>
          <Tooltip title="Quantidade em estoque" placement="bottom">
            <TextField
              id="estoque"
              name="estoque"
              label="Estoque"
              variant="outlined"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={item?.estoqueAtual ? item.estoqueAtual : ""}
              disabled={true}
            />
          </Tooltip>
        </Grid>
        <Grid item xs={1}>
          <Tooltip title="Unidade de venda" placement="bottom">
            <TextField
              id="unidade"
              name="unidade"
              label="Unidade"
              variant="outlined"
              margin="normal"
              InputLabelProps={{ shrink: true }}
              value={item?.unidade ? item.unidade : ""}
              onChange={handleInputChange}
              disabled={true}
              fullWidth
            />
          </Tooltip>
        </Grid>
        <Grid item xs={1.95}>
          <TextField
            id="quantidade"
            name="quantidade"
            label="Qtd"
            variant={"outlined"}
            disabled={
              nfSaidaId || !produto || !nfSaida?.operacaoFiscalId ? true : false
            }
            margin="normal"
            type="number"
            disableNumberArrows
            InputProps={{
              inputProps: item?.fracionavel
                ? { min: 0.01, step: 0.01 }
                : { min: 1, step: 1 },
              endAdornment: item?.embalagem ? (
                <InputAdornment position="end">
                  <Tooltip
                    placement="bottom"
                    title={
                      <div className="modelo-div-title">
                        Quantidade de embalagem pré - definida no cadastro do
                        produto
                      </div>
                    }
                    arrow
                  >
                    <i className="ph-fill ph-info" style={{ fontSize: 22 }}></i>
                  </Tooltip>
                </InputAdornment>
              ) : null,
            }}
            value={value.text(item?.quantidade)}
            onChange={(e) => {
              if (e.target.value <= 0) e.target.value = "";
              if (produto?.fracionavel) {
                e.target.value = Number(e.target.value);
              } else {
                e.target.value = Math.trunc(Number(e.target.value));
              }
              handleInputChange(e);
            }}
            onBlur={(e) => onBlurQtd(e)}
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          {acrescimoPagamento > 0 ? (
            <Tooltip
              title={`Esse valor tem acréscimo de ${acrescimoPagamento}% pela condição de pagamento escolhida`}
              placement="top"
            >
              <CurrencyInput
                id="valor"
                name="valor"
                label="Valor Unitário R$"
                value={item?.valor}
                variant={"outlined"}
                disabled={
                  nfSaidaId ||
                  !produto ||
                  !nfSaida?.operacaoFiscalId ||
                  !permissaoEditarPrecoVenda
                }
                onBlur={handleInputBlur}
              />
            </Tooltip>
          ) : (
            <CurrencyInput
              id="valor"
              name="valor"
              label="Valor Unitário R$"
              value={item?.valor}
              variant={"outlined"}
              disabled={
                nfSaidaId ||
                !produto ||
                !nfSaida?.operacaoFiscalId ||
                !permissaoEditarPrecoVenda
              }
              onBlur={handleInputBlur}
            />
          )}
        </Grid>
        <Grid item xs={2}>
          <CurrencyInput
            id="subTotal"
            name="subTotal"
            label="Total Item R$"
            variant={"outlined"}
            disabled={true}
            value={value.text(item?.valor * item?.quantidade)}
            onBlur={handleInputBlur}
          />
        </Grid>
        <Grid item xs={0.5}>
          <IconButton
            variant="contained"
            size="small"
            onClick={handleAddActionsOpen}
          >
            <i
              className="ph-bold ph-caret-down"
              style={{
                color: "#494c62",
                rotate: itensColumnView ? "180deg" : "0deg",
              }}
            ></i>
          </IconButton>
        </Grid>
        <Grid item xs={0.55} sx={{ mt: "0.5em" }}>
          {isProdutoEdit ? (
            <Button
              id="buttonAdicionar"
              variant="contained"
              disabled={nfSaidaId || !nfSaida?.operacaoFiscalId ? true : false}
              size="small"
              sx={{
                height: "35px",
                borderRadius: "50%",
                minWidth: "15px",
                boxShadow: "none",
              }}
              onClick={() => handleAdicionarProduto(produto, item)}
            >
              <i
                className="ph-bold ph-arrows-clockwise"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          ) : (
            <Button
              id="buttonAdicionar"
              variant="contained"
              color="success"
              disabled={nfSaidaId || !nfSaida?.operacaoFiscalId ? true : false}
              size="small"
              sx={{
                height: "35px",
                borderRadius: "50%",
                minWidth: "15px",
                boxShadow: "none",
              }}
              onClick={() => handleAdicionarProduto(produto, item)}
            >
              <i
                className="ph-bold ph-plus"
                style={{ color: "#fff", fontSize: 15 }}
              ></i>
            </Button>
          )}
        </Grid>
      </Grid>
      {itensColumnView && (
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextFielDecimalNumbers
                  id="descontoPorcentagem"
                  name="descontoPorcentagem"
                  label="Desconto (%)"
                  variant="outlined"
                  disabled={
                    nfSaidaId ||
                    !nfSaida?.descontoItem ||
                    produto?.tipo === "kit"
                  }
                  value={item?.descontoPorcentagem ?? 0}
                  onBlur={handleInputDesconto}
                />
              </Grid>
              <Grid item xs={6}>
                <CurrencyInput
                  id="desconto"
                  name="desconto"
                  label="Desconto (R$)"
                  variant="outlined"
                  disabled={
                    nfSaidaId ||
                    !nfSaida?.descontoItem ||
                    produto?.tipo === "kit"
                  }
                  value={item?.desconto ?? 0}
                  onBlur={handleInputDesconto}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2}>
            <CurrencyInput
              id="frete"
              name="frete"
              label="Frete"
              disabled={
                nfSaidaId || !nfSaida?.freteItem || produto?.tipo === "kit"
              }
              value={item?.frete ? item.frete : ""}
              onBlur={handleInputBlurAcrescimos}
            />
          </Grid>
          <Grid item xs={2}>
            <CurrencyInput
              id="despesas"
              name="despesas"
              label="Despesas"
              disabled={
                nfSaidaId || !nfSaida?.despesasItem || produto?.tipo === "kit"
              }
              value={item?.despesas ? item.despesas : ""}
              onBlur={handleInputBlurAcrescimos}
            />
          </Grid>
        </Grid>
      )}
      <Grid container spacing={4}>
        <Grid style={{ marginTop: 32 }} item xs={12}>
          <DataGrid
            style={{ zIndex: 1 }}
            rows={nfSaidaProdutos}
            columns={produtosColunas}
            rowCount={nfSaidaProdutos.length}
            disableAcoes
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row-reverse"
        justifyContent="flex-start"
        spacing={2}
        sx={{ mt: 2 }}
      >
        {tabelaCustoPermissao && nfSaidaProdutos.length > 0 && (
          <Grid
            item
            xs={2}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              className="mb-3"
              size="large"
              variant="contained"
              color="primary"
              onClick={() => handleOpenTabelaCustoDialog(true)}
            >
              <i
                className="ph-fill ph-table"
                style={{ color: "#fff", fontSize: 22, marginRight: 10 }}
              ></i>
              Tabela de Custo
            </Button>
          </Grid>
        )}
        {ordemCompraPermissao && nfSaidaProdutos.length > 0 && (
          <Grid
            item
            xs={3}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              className="mb-3"
              size="large"
              variant="contained"
              color="primary"
              onClick={() => setOpenOrdemCompraDialog(true)}
            >
              <i
                className="ph-fill ph-hand-coins"
                style={{ color: "#fff", fontSize: 22, marginRight: 10 }}
              ></i>
              Ordem de Compra
            </Button>
          </Grid>
        )}
      </Grid>
      <ProdutoSimilarDialog
        produto={produto}
        openProdutoSimilarDialog={openProdutoSimilarDialog}
        setOpenProdutoSimilarDialog={setOpenProdutoSimilarDialog}
        produtosColunasSimilares={produtosColunasSimilares}
        listaProdutosSimilares={listaProdutosSimilares}
      />
      <ProdutoEstoqueInformacaoDialog
        produto={produto}
        open={openProdutoEstoqueInformacaoDialog}
        setOpen={setOpenProdutoEstoqueInformacaoDialog}
        usuario={usuario}
        handleChangeAutocompleteProduto={handleChangeAutocompleteProduto}
      />
      <ImpostoProdutoDialog
        open={openImpostoProdutoDialog}
        setOpen={setImpostoProdutoDialog}
        produto={produto}
        setProduto={setProduto}
        origensMercadoriasList={origensMercadoriasList}
        situacaoIpiList={situacaoIpiList}
        enquadramentoLegalList={enquadramentoLegalList}
        gruposTributacaoList={gruposTributacaoList}
        csoSimplesList={csoSimplesList}
        situacaoIbsList={situacaoIbsList}
        classificacaoIbsList={classificacaoIbsList}
        modeloTributacao={modeloTributacao}
        nfSaida={nfSaida}
        nfSaidaId={nfSaidaId}
        nfSaidaProdutos={nfSaidaProdutos}
        setNfSaidaProdutos={setNfSaidaProdutos}
        nfSaidaEntity={nfSaidaEntity}
      />
      <DocumentoProdutoAplicacaoDialog
        open={openProdutoAplicacoesDialog}
        setOpen={setOpenProdutoAplicacoesDialog}
        aplicacoesProduto={produto?.aplicacoes}
      />
      <TabelaCustoDialog
        openDialog={openTabelaCustoDialog}
        setOpenDialog={setOpenTabelaCustoDialog}
        produtos={produtosTabelaCusto}
        totais={totaisTabelaCusto}
      />
      <OrdemCompraDialog
        openDialog={openOrdemCompraDialog}
        setOpenDialog={setOpenOrdemCompraDialog}
        itens={nfSaidaEntity.nfSaidaItens}
        produtos={nfSaidaProdutos}
        setProdutos={setNfSaidaProdutos}
      />
    </Grid>
  );
};

export default NfSaidaItens;
